import { getUserProfile } from "./auth-api";
import { CreatingCompanyProfile } from "./components/CreatingCompanyProfile/CreatingCompanyProfile";
import type { UserCompanyProfile } from "./types/UserCompanyProfile.type";
import {
	clearGuestUser,
	makeCompanyProfileFromGuest,
	refreshLoadedCompanyProfile,
	refreshLoadedUserProfile,
} from "./utils";

export default CreatingCompanyProfile;

export type { UserCompanyProfile };

export const authentication = {
	api: { getUserProfile },
	clearGuestUser,
	makeCompanyProfileFromGuest,
	refreshLoadedCompanyProfile,
	refreshLoadedUserProfile,
};
